<template lang="pug">
#news
  vheader
  mobile-nav
  .intro
    .container
      .menu
        .menu_li(@click="changeType()" :class="{'active': !type}") 全部
        .menu_li(@click="changeType('workshop')" :class="{'active': type === 'workshop'}") 前沿工作坊
        .menu_li(@click="changeType('camp')" :class="{'active': type === 'camp'}") 超频之旅
        .menu_li(@click="changeType('study')" :class="{'active': type === 'study'}") 近场研究
      #waterfall.news-wapper
        article.news-item(v-for="item in activities" :key="item.id")
          .banner(:style="{backgroundImage: 'url(' + item.avatar_url + '?imageView2/1/w/1069/h/620/interlace/1/q/88/interlace/1/)'}")
            .activity-type
              .en
                | FRONTIER
                br
                | {{item.activity_type}}
              .cn {{item.activity_type | getCN}}
          .content
            .activity-content
              h4 {{item.title}}
              p {{item.description}}
            .activity-guests(v-if="item.guests")
              .title 特邀嘉宾
              .guests
                .guest(v-for="guest in item.guests")
                  .avatar
                    img(:src="`${guest.avatar_url}?imageView2/2/w/100/interlace/1/q/88/interlace/1/`")
                  .info
                    p.title {{guest.name}}
                    p.from {{guest.company}}
                    p.position {{guest.duty}}
            .activity-meta
              a.link(:href="item.article_link" target="_blank") 了解更多 >
              .time {{item.activity_time | formatTime}}
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import Vfooter from '../components/Vfooter.vue'
import api from '../store/api'

const CNNAME = {workshop: '前沿工作坊', camp: '超频之旅', study: '近场研究'}
let page = 0

export default {
  components: {
    Vheader,
    Vfooter,
    MobileNav
  },
  data () {
    return {
      type: '',
      activities: [],
      all_activities: [],
      page: page,
      totalPage: 0,
      loading: false
    }
  },
  mounted () {
    this.getActivity()
    window.addEventListener('scroll', () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop + window.innerHeight + 100 >= document.body.clientHeight && !this.loading && page < this.totalPage) {
        this.getActivity()
      }
    })
  },
  methods: {
    getActivity () {
      this.loading = true
      page += 1
      api.get(`admin/activities?per=100&page=${page}`).then((result) => {
        this.totalPage = result.data.meta.total_pages
        this.all_activities = this.activities.concat(result.data.activities.sort(function(a, b) {
          return new Date(b.activity_time) - new Date(a.activity_time)
        }))
        this.changeType()
        this.loading = false
      }).catch((err) => {
        console.log(err.toString())
      })
    },
    changeType (type) {
      if (type) {
        this.type = type
        this.activities = this.all_activities.filter(item => item.activity_type === type)
      } else {
        this.type = ''
        this.activities = this.all_activities
      }
      this.$nextTick(this.waterfall)
    },
    waterfall() {
      if((document.documentElement.offsetWidth || document.body.offsetWidth) < 767) {
        return
      }
      var waterfallParent = document.getElementById("waterfall");
      var flowItems = waterfallParent.getElementsByClassName("news-item");
      var pin = [];

      var flow = {
        parent: waterfallParent,
        flowItems: flowItems,
        pin: 3,
        width: 330,
        horizontalMargin: 15,
        verticalMargin: 15
      };

      for(var i = 0, len = flowItems.length; i < len; i++) {
        flowItems[i].style.width = flow.width + "px";
        if(i < flow.pin){
          pin[i] = flowItems[i].clientHeight;
          flowItems[i].style.top = 0;
          flowItems[i].style.left = i * (flow.width + flow.horizontalMargin) + "px";
        } else {
          // 获取pin数组中的最小值
          var minH = Math.min.apply(null, pin);
          // 获取高度数组中最小高度的索引
          var minHItem = pin.indexOf(minH);
          // 把当前元素在视觉上置于最小高度的一列
          flowItems[i].style.left = minHItem * (flow.width + flow.horizontalMargin) + "px";
          flowItems[i].style.top = minH + flow.verticalMargin + "px";
          // 重置列的高度
          pin[minHItem] += flowItems[i].clientHeight + flow.verticalMargin;
        }
      }
      // 计算瀑布流容器
      flow.parent.style.width = flow.pin * flow.width + (flow.pin - 1) * flow.horizontalMargin + "px";
      flow.parent.style.height = Math.max.apply(null, pin) + 50 + "px";
    }
  },
  filters: {
    formatTime (val) {
      let date = new Date(val)
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    getCN (val) {
      return CNNAME[val]
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var';

#news
  width 100%
  background #fff
  padding-top 30px
  // height 100%
  .menu
    border-bottom 1px solid #000
    display inline-block
    margin 30px
    .menu_li
      display inline-block
      line-height 2
      padding 0 .5em
      font-size 14px
      border-radius 4px 4px 0 0
      cursor pointer
      margin 0 5px
      &.active
        background #000
        color #fff
  .news-wapper
    position relative
    margin 0 auto
    .news-item
      position absolute
      color #fff
      line-height 1.5em
      .banner
        background url(../assets/imgs/x.jpg) no-repeat center top
        background-size cover
        position relative
        padding-bottom 54%
        .activity-type
          background #000
          display inline-block
          padding .5em
          .en, .cn
            display inline-block
            vertical-align middle
          .en
            margin-right .4em
            font-family 'BebasNeue'
            line-height .9
            text-align right
          .cn
            font-family 'FZLTTHCJW--GB1-0'
            font-size 1.2em
      .content
        padding 15px 20px
        background #000
        .activity-content
          h4
            font-size 20px
            font-weight 900
            line-height 1.2
            margin-bottom .3em
          p
            font-size 14px
            color #999
        .activity-guests
          padding-top 25px
          .title
            font-size 16px
            font-weight 700
          .guests
            margin 15px 0
            .guest
              display inline-block
              .avatar
                float left
                width 50px
                height 50px
                border-radius 50%
                margin-right 10px
                overflow hidden
                img
                  width 50px
                  vertical-align top
              .info
                display inline-block
              p.title
                font-size 16px
              p.from
                font-size 13px
              p.position
                color #999
        .activity-meta
          margin-top 20px
          border-top 1px solid #fff
          padding-top .5em
          .time
            font-size 14px
          .link
            color #5EC5FF
            float right
  @media $media
    .menu
      margin 30px 0
    .news-wapper
      height auto
      .news-item
        position static
        margin-bottom 20px
</style>



// WEBPACK FOOTER //
// News.vue?53b196f8